import { reactive, ref } from "vue";
import { skapi } from "@/main";
import {
    serviceList,
    serviceIdList,
    endOfList,
} from "@/views/service-list";
import { track } from "@/user_tracker";
import { miscUpdater } from "@/code/misc";

export let user: { [key: string]: any } = reactive({});
export let customer: Promise<Customer> = null;
export let emailSubscribed = ref(null);

type Customer = {
    id: string;
    object: "customer";
    address: {
        city: string;
        country: string;
        line1: string;
        line2: string;
        postal_code: string;
        state: string;
    };
    balance: number;
    created: number;
    currency: string;
    default_source: any;
    delinquent: boolean;
    description: any;
    discount: any;
    email: string;
    invoice_prefix: string;
    invoice_settings: {
        custom_fields: any;
        default_payment_method: any;
        footer: any;
        rendering_options: any;
    };
    livemode: boolean;
    metadata: {
        [key: string]: any;
    };
    name: string;
    next_invoice_sequence: number;
    phone: any;
    preferred_locales: any[];
    shipping: any;
    tax_exempt: string;
    test_clock: any;
};

export let initUser = (userIncoming: any) => {
    for (let k in user) {
        delete user[k];
    }
    if (userIncoming) {
        for (let k in userIncoming) {
            user[k] = userIncoming[k];
        }
    }
};

export let userLoginCallback = async (userIncoming: any) => {
    console.log("User login callback triggered with user:", userIncoming);
    if (userIncoming) {
        let userIncomingMisc = JSON.parse(userIncoming.misc || "{}");

        getStripeCustomer(userIncoming);

        // get newsletter subscription status
        if (emailSubscribed.value === null) {
            let subs = await skapi
                .getNewsletterSubscription({
                    group: "authorized",
                });
            emailSubscribed.value = !!subs.length;
        }

        // auto subscribe google users to newsletter
        if (
            userIncoming?.signup_ticket &&
            userIncoming?.signup_ticket === "OIDPASS" &&
            emailSubscribed.value === null &&
            !userIncomingMisc.googleUserSubscribed
        ) {
            await skapi.subscribeNewsletter({
                group: "authorized",
            });
            userIncomingMisc.googleUserSubscribed = true;
            miscUpdater({ googleUserSubscribed: true });
            emailSubscribed.value = true;
        }
    }
    else {
        emailSubscribed.value = null;

        while (serviceIdList.value.length > 0) {
            serviceIdList.value.pop();
        }
        for (let k in serviceList) {
            delete serviceList[k];
        }

        endOfList.value = false;
    }
};

let getStripeCustomer = async (user: any) => {
    let misc;

    if (user?.misc && typeof user.misc === "string") {
        misc = JSON.parse(user.misc);
    } else {
        misc = {};
    }

    if (misc?.stripe_customer_id) {
        // stripe_customer_id exists

        let customer_id = misc.stripe_customer_id;

        // get customer info, and update customer.value
        customer = skapi.clientSecretRequest({
            clientSecretName: "stripe_test",
            url: `https://api.stripe.com/v1/customers/${customer_id}`,
            method: "GET",
            headers: {
                Authorization: "Bearer $CLIENT_SECRET",
            },
        });
    } else {
        // stripe_customer_id does not exist

        // create customer, save customer id in user misc
        customer = skapi.clientSecretRequest({
            clientSecretName: "stripe_test",
            url: "https://api.stripe.com/v1/customers",
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer $CLIENT_SECRET",
            },
            data: {
                name: user.name || user.email,
                email: user.email,
            },
        });

        // update customer id in user misc
        customer.then(async (c) => {
            if (c) {
                misc.stripe_customer_id = c.id;
                miscUpdater({
                    stripe_customer_id: misc.stripe_customer_id,
                });
            }
        });
    }
};

export function genOAuthCallbackUrl(oauthState: string, session: any) {
    let oauthRedirectUri = "";

    // get session storage item
    let oauthParams = window.sessionStorage.getItem("oauth:" + oauthState);

    console.log("oauthParams from sessionStorage:", oauthParams);
    if (oauthParams) {
        const parsedParams = JSON.parse(oauthParams);
        oauthRedirectUri = parsedParams.redirect_uri || "";
    }

    if (!oauthRedirectUri) {
        return "";
    }

    let code = {
        access_token: session.accessToken.jwtToken,
        refresh_token: session.refreshToken.token,
        id_token: session.idToken.jwtToken,
    };

    // Base64 encode to make it URL-safe
    const encodedCode = btoa(JSON.stringify(code));

    return oauthRedirectUri +
        (oauthRedirectUri.includes("?") ? "&" : "?") +
        "code=" + encodeURIComponent(encodedCode) +
        "&state=" + encodeURIComponent(oauthState);
}